import React from 'react';

import { Grid, makeStyles } from "@material-ui/core";
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';

const useStyles = makeStyles((theme) => ({
    footer: {
        fontSize: "1em",
        alignItems: 'flex-start',
        paddingTop: theme.spacing(1),
        background: '#3A3B3F 0% 0% no-repeat padding-box',
        opacity: 1,
        color: theme.palette.common.white,
        paddingLeft: 25,
    },
    legalColumn: {
        fontSize: '.75em',
        flexDirection: 'column',
        paddingRight: '10px'
    },
    yellowA: {
        color: theme.palette.primary.main,
        fontSize: '.75em',
    },
    whiteA: {
        color: theme.palette.common.white,
        fontSize: '.75em',
    },
}));

const Footer: React.FunctionComponent = () => {
    const styles = useStyles()
    const today = new Date
    // noinspection HtmlUnknownTarget
    return (
        <Grid container className={styles.footer} id={"footer"}>
            <Grid className={styles.legalColumn} item xs={12} md={7}>
                <p aria-label={"copyright"}>©{today.getFullYear()} by eFuneral. All Rights Reserved.</p>
                <p>Life insurance and annuity products are issued by Homesteaders Life Company. Products are
                                subject to state availability.</p>
                <p>Any information regarding Homesteaders Life Company's products is intended solely for
                                licensed insurance and funeral professionals.</p>
                <p>Texas consumers visit <a className={styles.yellowA}
                    href='www.prepaidfunerals.texas.gov'>www.prepaidfunerals.texas.gov</a> for
                                more information.</p>
            </Grid>
            <Grid container item xs={12} md={5}>
                <Grid container direction={"column"} item xs={7}>
                    <Grid item direction={"row"}>
                        <p>eFUNERAL ONLINE</p>
                    </Grid>
                    <Grid container item direction={"row"}>
                        <Grid item>
                            <a className={styles.whiteA} href='https://www.efuneral.com/terms-of-use'>Terms of
                                        Use</a><br />
                            <a className={styles.whiteA} href='https://www.efuneral.com/privacy-policy'>Privacy
                                        Policy</a><br />
                            <a className={styles.whiteA} href='https://partner.efuneral.com/'>Become a
                                        Partner</a><br />
                        </Grid>
                        <Grid item>
                            <a className={styles.whiteA} href='https://www.efuneral.com/careers'>Careers</a>
                            <br />
                            <a className={styles.whiteA} href='https://www.efuneral.com/contact-us'> Contact
                                        Us </a><br />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item xs={5}>
                    <Grid item>
                        <p> eFUNERAL ONLINE </p>
                    </Grid>
                    <Grid container item>
                        <Grid item xs={2}>
                            <FacebookIcon />
                        </Grid>
                        <Grid item xs={2}>
                            <InstagramIcon />
                        </Grid>
                        <Grid item xs={2}>
                            <TwitterIcon />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Footer;
